export default __webpack_public_path__ + "static/media/cosmos.4b82322c.svg";